export default __webpack_public_path__ + "static/media/visa-logo.6bbc846f.png";